import { inject, Injectable } from '@angular/core';
import {
    Auth,
    createUserWithEmailAndPassword,
    indexedDBLocalPersistence,
    inMemoryPersistence,
    signInWithEmailAndPassword
} from '@angular/fire/auth';
import { User } from 'firebase/auth';

@Injectable({
    providedIn: 'root'
})
export class AuthEmailPasswordService {
    private readonly fireAuth = inject(Auth);

    public async signIn(
        email: string,
        password: string,
        shouldRememberMe: boolean
    ): Promise<User | null> {
        const persistence = shouldRememberMe ? indexedDBLocalPersistence : inMemoryPersistence;

        this.fireAuth.setPersistence(persistence);

        const credential = await signInWithEmailAndPassword(this.fireAuth, email, password);

        return credential.user;
    }

    public async signUp(email: string, password: string): Promise<User | null> {
        const credential = await createUserWithEmailAndPassword(this.fireAuth, email, password);

        return credential.user;
    }

    public getErrorCodeMessage(errorCode: string): string {
        switch (errorCode) {
            case 'auth/email-already-in-use':
                return 'An account with this email address already exists.';
            case 'auth/invalid-email':
                return 'The email address format is invalid.';
            case 'auth/operation-not-allowed':
                return 'Email/password authentication is not enabled.';
            case 'auth/weak-password':
                return 'The password is too weak.';
            case 'auth/user-disabled':
                return 'This user has been disabled.';
            case 'auth/user-not-found':
                return 'No user found with this email address.';
            case 'auth/wrong-password':
                return 'Incorrect password.';
            default:
                return 'An unknown error occurred. Please try again.';
        }
    }
}
